<template>
    <uw-content title="出库单">

        
        <template slot="suffix">
            <el-button type="primary" size="mini" @click="$refs.createBack.Open()" >新建出库单</el-button>
        </template>

        
        <uw-table>
            
            
            <template slot="search">
                <ims-warehouse-select  v-model="search.warehoser_id" @onChange="TableSearch()" />
            </template>

            
            <template slot="button">
                <el-button type="primary" size="mini" @click="$refs.xTable.openExport()" >导出</el-button>
            </template>

            
            <template slot="data">
                <vxe-table
                    ref="xTable"
                    :data="table"
                    :loading="loading"
                    :export-config="{}"
                    :print-config="{}"
                    :seq-config="{startIndex: page.size * (page.current - 1)}"
                    height="100%">

                    
                    <vxe-column width="80" title="状态">
                        <template #default="{ row }">
                            <el-tag effect="dark" size="mini" v-if="row.state">已出库</el-tag>
                            <el-tag effect="dark" size="mini" v-if="!row.state" type="danger">已作废</el-tag>
                        </template>
                    </vxe-column>

                    
                    <vxe-column width="100" title="出库类型">
                        <template #default="{ row }">
                            <span v-if="row.model == 'other'">其它出库</span>
                            <span v-if="row.model == 'ims_warehouse_move'">库存调拨</span>
                            <span v-if="row.model == 'ims_product_back'">退货订单</span>
                            <span v-if="row.model == 'ims_product_invalid'">产品报废</span>
                            <span v-if="row.model == 'ims_product_apply'">产品申领</span>
                        </template>
                    </vxe-column>

                    
                    <vxe-column min-width="120" field="number" title="出库单号"></vxe-column>

                    
                    <vxe-column min-width="120" title="关联订单">
                        <template #default="{ row }">
                            <span class="el-span-primary" v-if="row.model == 'ims_warehouse_move'" @click="$refs.warehouseMoveDrawer.Open(row.model_id)">{{ row.model_number }}</span>
                            <span class="el-span-primary" v-if="row.model == 'ims_product_back'" @click="$refs.productBackDrawer.Open(row.model_id)">{{ row.model_number }}</span>
                            <span class="el-span-primary" v-if="row.model == 'ims_product_invalid'" @click="$refs.productInvalidDrawer.Open(row.model_id)">{{ row.model_number }}</span>
                            <span class="el-span-primary" v-if="row.model == 'ims_product_apply'" @click="$refs.productApplyDrawer.Open(row.model_id)">{{ row.model_number }}</span>
                        </template>
                    </vxe-column>

                    
                    <vxe-column width="140" field="created_at" title="出库时间"></vxe-column>
                    <vxe-column min-width="120" field="describe" title="备注"></vxe-column>
                    <vxe-column width="100" field="created_user.name" title="负责人"></vxe-column>

                </vxe-table>
            </template>

            
            <template slot="pager">
                <vxe-pager :total="page.total" :page-size.sync="page.size" :current-page.sync="page.current" @page-change="TableSearch()"></vxe-pager>
            </template>

        </uw-table>

        
        <ims-warehouse-document-create-back ref="createBack" @onChange="TableSearch" />
        <ims-order-drawer ref="productOrderDrawer" @onChange="TableSearch" />
        <ims-product-back-drawer ref="productBackDrawer" @onChange="TableSearch" />
        <ims-product-invalid-drawer ref="productInvalidDrawer" @onChange="TableSearch" />
        <ims-product-apply-drawer ref="productApplyDrawer" @onChange="TableSearch" />

    </uw-content>
</template>

<script>
export default {
    data () {
        return {
                        loading: false,

            table: [],

                        page: {
                total: 0,
                size: 50,
                current: 1,
            },

                        search: {
                warehoser_id: null,
                number: null,
                action: 0
            },

                        order: {
                method: 'desc',
                column: 'id'
            },
        }
    },

    mounted () {
        this.TableSearch()
    },

    methods: {

                TableSearch() {
                        this.loading = true

            this.$http.post(
                '/9api/ims/warehouse-document/search',
                {
                    page: this.page,
                    search: this.search,
                    order: this.order,
                    append: ['created_user', 'model_number']
                }
            ).then(rps => {
                
                                this.page.total = rps.data.total
                this.table = rps.data.body

                                if (this.table.length == 0 && this.page.current != 1) {
                    this.page.current = 1
                    this.TableSearch()
                }

                                this.loading = false
            })
        }
    }

}
</script>